import React,{Component} from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, UncontrolledTooltip, CardFooter } from "reactstrap";
import { renderField, number, renderCheckbox, required } from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getServers, updateServer} from "../../../actions/actionServer";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import SelectInput from "../../../components/SelectInput";

class AgentFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentServer: null,
        };
        this.submitServer= this.submitServer.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    }

    handleUpdateSuccess(){
        const {updateErrorServerMessage} = this.props;
        if(updateErrorServerMessage){
            NotificationManager.error(updateErrorServerMessage,"Update Agent", 3000);
        }
        else {
            NotificationManager.success("Agent Update", "Successfully Updated Agent");
            this.props.history.push("/agents");
        }
    }

    handleUpdateError(){
        const {updateServerError} = this.props;
        if(updateServerError){
            NotificationManager.error(updateServerError,"Update Agent", 3000);
        }
    }


    submitServer(userData){
        userData.server_id = this.state.currentServer.server_id;
        this.props.updateServer(userData).
            then(() => this.handleUpdateSuccess()).
            catch(() => this.handleUpdateError());
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.servers.length > 0 && this.props.servers !== nextProps.servers && this.props.getServersLoading && this.props.fromUpdate){
            let currentServer= nextProps.servers.find(servers => servers.server_id === this.props.serverId);
            //let currentServers =  nextProps.servers.find(servers => servers.server_id === currentImage.server_id);
            this.setState({currentServer: currentServer});
            this.props.initialize({
                memory_override: currentServer.memory_override,
                cores_override: currentServer.cores_override,
                server_id: currentServer.server_id,
                enabled: currentServer.enabled,
                prune_images_mode: currentServer.prune_images_mode,
            });
        }
    }

    cancelButton(){
        this.props.history.push("/agents");
    }

    componentDidMount(){
        if (this.props.fromUpdate){
            this.props.getServers();
        }
    }

    render(){
        const {handleSubmit, agentFormValues} = this.props;
        let prune_images_options = [
            {label: "Off", value: "Off"},
            {label: "Normal", value: "Normal"},
            {label: "Aggressive", value: "Aggressive"}
        ];
        //const checked = true;
        return (
            <Form onSubmit={handleSubmit(this.submitServer)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="enabled" className="requiredasterisk">Enabled</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                    name="enabled"
                                    id="enabled"
                                    component={renderCheckbox}
                                    //check={checked}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="6">
                                <Label htmlFor="prune_images_mode" className="requiredasterisk">Automatically Prune Images</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="prune_images_mode"
                                       selectedValue={agentFormValues && agentFormValues.prune_images_mode ? agentFormValues.prune_images_mode: ""}
                                       options={prune_images_options}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="cores_override" className="requiredasterisk">Cores Override</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="number"
                                    name="cores_override"
                                    id="cores_override"
                                    component={renderField} 
                                    validate={[ number]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="memory_override" className="requiredasterisk">Memory Override</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="number"
                                    name="memory_override"
                                    id="memory_override"
                                    component={renderField} 
                                    validate={[ number]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                </CardBody> 
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm" 
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}> Cancel</Button>
                        <Button type="submit" size="sm" 
                        className="submit-button" 
                        color="primary">Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

AgentFormTemplate.propTypes = {
    updateServer: Proptypes.func.isRequired,
    getServers: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    updateServerError: Proptypes.func,
    updateErrorServerMessage: Proptypes.string,
    fromUpdate: Proptypes.bool,
    servers: Proptypes.array,
    getServeraLoading: Proptypes.bool,
    initialize: Proptypes.func,
    agentFormValues: Proptypes.object,
    handleSubmit: Proptypes.func,
    serverId: Proptypes.string,
};

let AgentFormWithRouter = withRouter(AgentFormTemplate);

let AgentForm =  connect(state =>
    ({
        servers: state.servers.servers || [],
        agentFormValues: state.form && state.form.agentForm && state.form.agentForm.values ? state.form.agentForm.values : null,
        updateErrorServerMessage: state.servers.updateErrorServerMessage || null,
        updateServerError: state.servers.updateServerError || null,
        getServersLoading: state.servers.getServersLoading || false,
    }),
dispatch => 
    ({
        updateServer: (data) => dispatch(updateServer(data)),
        getServers: () => dispatch(getServers()),
    }))(AgentFormWithRouter);

export default reduxForm({
    form: "agentForm",
})(AgentForm);


// WEBPACK FOOTER //
// ./src/views/Agents/AgentForm/AgentForm.js